import Vue from 'vue'
import Page from '@hui-pro/page'
import Layout from '@hui-pro/layout'
import Empty from '@hui-pro/empty'

Vue.use(Page)
Vue.use(Layout)
Vue.use(Empty)
